import { render } from "./language.vue?vue&type=template&id=26e999da&scoped=true"
import script from "./language.vue?vue&type=script&lang=js"
export * from "./language.vue?vue&type=script&lang=js"

import "./language.vue?vue&type=style&index=0&id=26e999da&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26e999da"]])

export default __exports__